import React, { useEffect, useState } from 'react';
import { Check, X } from 'lucide-react';
const buyers = [{
  name: 'Chloe T.',
  location: 'Sydney',
  minutes: 4
}, {
  name: 'Emma R.',
  location: 'London',
  minutes: 12
}, {
  name: 'Olivia K.',
  location: 'New York',
  minutes: 23
}, {
  name: 'Sophie M.',
  location: 'Toronto',
  minutes: 7
}, {
  name: 'Isabella P.',
  location: 'Melbourne',
  minutes: 18
}];
export function PurchaseNotification() {
  const [visible, setVisible] = useState(false);
  const [idx, setIdx] = useState(0);
  useEffect(() => {
    const showTimer = setTimeout(() => setVisible(true), 4000);
    return () => clearTimeout(showTimer);
  }, []);
  useEffect(() => {
    if (!visible) return;
    const cycle = setInterval(() => {
      setVisible(false);
      setTimeout(() => {
        setIdx(i => (i + 1) % buyers.length);
        setVisible(true);
      }, 800);
    }, 9000);
    return () => clearInterval(cycle);
  }, [visible]);
  const buyer = buyers[idx];
  return <div className={`fixed bottom-4 left-4 z-50 transition-all duration-500 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none'}`} data-id="element-183">
      <div className="bg-white rounded-2xl shadow-2xl border border-pilates-sage/20 p-3 pr-4 flex items-center gap-3 max-w-[300px]" data-id="element-184">
        <div className="bg-pilates-sage-dark w-9 h-9 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-185">
          <Check className="w-5 h-5 text-white" strokeWidth={3} data-id="element-186" />
        </div>
        <div className="flex-1 min-w-0" data-id="element-187">
          <p className="text-sm font-semibold text-pilates-dark leading-tight truncate" data-id="element-188">
            {buyer.name}, from {buyer.location}
          </p>
          <p className="text-xs text-pilates-slate leading-tight mt-0.5" data-id="element-189">
            Just purchased • {buyer.minutes} min ago •{' '}
            <span className="text-pilates-sage-dark font-semibold" data-id="element-190">
              Verified Purchase
            </span>
          </p>
        </div>
        <button onClick={() => setVisible(false)} className="text-pilates-slate hover:text-pilates-dark flex-shrink-0" aria-label="Close" data-id="element-191">
          <X className="w-4 h-4" data-id="element-192" />
        </button>
      </div>
    </div>;
}